import React from "react";

const DivConfiguracaoAgendamento = ({
    idPrefix = "horario-atendimento",
    horario,
    onChange,
    onExcluir,
}) => {
    const diaSemanaId = `${idPrefix}-dia-semana`;
    const inicioId = `${idPrefix}-inicio`;
    const fimId = `${idPrefix}-fim`;
    const diasDaSemana = [
        { nome: "Domingo", valor: "DOMINGO" },
        { nome: "Segunda-feira", valor: "SEGUNDA_FEIRA" },
        { nome: "Terça-feira", valor: "TERCA_FEIRA" },
        { nome: "Quarta-feira", valor: "QUARTA_FEIRA" },
        { nome: "Quinta-feira", valor: "QUINTA_FEIRA" },
        { nome: "Sexta-feira", valor: "SEXTA_FEIRA" },
        { nome: "Sábado", valor: "SABADO" },
    ];

    return (
        <>
            <div class="flex items-center justify-between mb-3">
                <div class="relative max-w-sm">
                    <label for={diaSemanaId} class="sr-only">
                        Dia da semana:
                    </label>
                    <select
                        id={diaSemanaId}
                        name={diaSemanaId}
                        class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        value={horario.diasDaSemana}
                        onChange={(event) =>
                            onChange("diasDaSemana", event.target.value)
                        }
                        required
                    >
                        <option value="" disabled>
                            Dia da semana
                        </option>
                        {diasDaSemana.map((dia) => (
                            <option key={dia.valor} value={dia.valor}>
                                {dia.nome}
                            </option>
                        ))}
                    </select>
                </div>
                <div class="w-full max-w-[7rem]">
                    <label for={inicioId} class="sr-only">
                        Início:
                    </label>
                    <div class="relative">
                        <input
                            type="time"
                            id={inicioId}
                            name={inicioId}
                            class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            min="09:00"
                            max="18:00"
                            value={horario.horaInicio}
                            onChange={(event) =>
                                onChange("horaInicio", event.target.value)
                            }
                            required
                        />
                    </div>
                </div>
                <div class="w-full max-w-[7rem]">
                    <label for={fimId} class="sr-only">
                        Fim:
                    </label>
                    <div class="relative">
                        <input
                            type="time"
                            id={fimId}
                            name={fimId}
                            class="bg-gray-50 border leading-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            min="09:00"
                            max="18:00"
                            value={horario.horaFim}
                            onChange={(event) =>
                                onChange("horaFim", event.target.value)
                            }
                            required
                        />
                    </div>
                </div>
                <div>
                    <button
                        id="excluirHorarioAtendimento"
                        onClick={onExcluir}
                        type="button"
                        class="inline-flex items-center p-1.5 text-sm font-medium text-center text-gray-500 hover:text-gray-800 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg focus:outline-none dark:text-gray-400 dark:hover:text-gray-100"
                    >
                        <svg
                            class="w-5 h-5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M8.586 2.586A2 2 0 0 1 10 2h4a2 2 0 0 1 2 2v2h3a1 1 0 1 1 0 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V8a1 1 0 0 1 0-2h3V4a2 2 0 0 1 .586-1.414ZM10 6h4V4h-4v2Zm1 4a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Zm4 0a1 1 0 1 0-2 0v8a1 1 0 1 0 2 0v-8Z"
                                clip-rule="evenodd"
                            />
                        </svg>
                        <span class="sr-only">Excluir</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default DivConfiguracaoAgendamento;
